import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=1e873b13&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=1e873b13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e873b13",
  null
  
)

export default component.exports